import {PromotionType} from "../../helpers/PromotionType";

export interface IPromotionListFilterFields {
    type?: PromotionType | null;
}

export const promotionListFilterFields = {};
import {PromotionType} from "../../helpers/PromotionType";

export interface IPromotionListFilterFields {
    type?: PromotionType | null;
}

export const promotionListFilterFields = {};
